import { ToastMessageContext } from "lib/contexts/message_context";
import { JobClockingServices } from "lib/services/api/operaitons/WorkShop/Job_Clockings/job_clockings_services";
import { useRef, useState, useEffect, useContext } from "react";


/**
 * useDynamicApi
 * - Accepts initial params once
 * - Allows override params at call time
 * - Exposes loading, error, response
 */
const useStopAllJobClockings = (initialParams = {}, options = {}) => {
    const { handleClose } = options;

    const paramsRef = useRef(initialParams);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [response, setResponse] = useState(null);
    const message = useContext(ToastMessageContext)
    // Keep params in sync if they change
    useEffect(() => {
        paramsRef.current = initialParams;
    }, [initialParams]);

    const stopClockIn = async (overrideParams) => {
        const finalParams = overrideParams ?? paramsRef.current;

        try {
            setLoading(true);
            setError(null);

            const res = await JobClockingServices.bulkStopAlljob(finalParams);

            if (res?.data) {
                setResponse(res?.data)
                message.showToastMessage({ message: `Success - ${res?.data?.job_clockings_updated} Job Clockings Stopped !`, variant: 'success' })
            }


            handleClose();

            return res;
        } catch (err) {
            message.showToastMessage({ message: err?.message || "Something Went Wrong !", variant: 'error' })
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return {
        stopClockIn,
        loading,
        error,
        response,
    };
};

export default useStopAllJobClockings;
